import { AntwortDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/antwort-display-model';
import { FrageDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/frage-display-model';
import { AnfrageService, AntwortService } from '@/api/service-index';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { StateService } from '@/core/services/state.service';
import { Component } from '@angular/core';
import { FormGroup, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Constants } from '@/constants';
import { GlobalEnumsAceFeldtyp } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-feldtyp';
import { SectionService } from '@/core/services/section.service';
import { GlobalEnumsAceXfoundportalobjekt } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt";
import { PortalContextService } from '@/core/services/portal-context.service';
import { AnfrageDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-display-model';
import { EnumValue } from '@/core/models/enumvalue.model';
import { AnfrageNavigationFormComponent, MoveDirection } from '../../../../components/anfrage-navigation-form/anfrage-navigation-form.component';
import { I18nService } from '@/core/services/i18nService';
import { CKEditorService } from '@/core/services/ckeditor.service';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { FragenVonAbschnittDisplayModel } from '@/api/model-index';
import { NumberFormatOptions } from '@progress/kendo-angular-intl';

@Component({
  selector: 'fragen-process-step',
  templateUrl: './fragen-process-step.component.html',
  styleUrls: ['./fragen-process-step.component.scss']
})
export class FragenProcessStepComponent extends AnfrageNavigationFormComponent {
  public Editor = ClassicEditor;

  public editorConfig = Constants.EDITOR_CONFIG;

  public fragenStepForm: UntypedFormGroup;
  public fragen: FrageDisplayModel[]
  public abschnittId: string;
  protected canceledRoute: string;

  public auswahlOptionen: Map<string, EnumValue[]>;

  public currencyFormatOptions: NumberFormatOptions = Constants.CURRENCY_FORMAT_OPTIONS;

  public fieldTypeEnum = GlobalEnumsAceFeldtyp;

  public get formGroup(): FormGroup<any> {
    return this.fragenStepForm;
  }
  
  public get fragenForm(): UntypedFormArray {
    return <UntypedFormArray>this.fragenStepForm.controls[this.abschnittId];
  }

  public get dateFormat(): string{
    return this.languageService.GetCurrentShortDateFormat(true);
  }

  constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService, 
    protected sectionService: SectionService, protected route: ActivatedRoute, 
    protected loadingAnimationService: LoadingAnimationService, protected router: Router, 
    protected antwortService: AntwortService, protected stateService: StateService, protected languageService: I18nService, public ckeditorService: CKEditorService, 
    protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) {
    super(sectionService, router, route, portalContextService);

    this.loadViewData();

    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.loadViewData();
      }
    })

    this.languageService.languageChanged$.subscribe(() => {
      this.fragen.forEach(frage => {
        this.updateEnumDescriptionOfOptions(frage);
      });
      this.fragenForm.controls.forEach(frage => {
        this.updateEnumDescriptionOfSelectedOptions(frage);
      })
    })
  }

  loadViewData() {
    this.fragen = this.route.snapshot.data.fragen;
    this.abschnittId = <string>this.route.snapshot.params['abschnittid'];
    this.auswahlOptionen = new Map();

    this.fragenStepForm = new UntypedFormGroup({});
    this.fragenStepForm.addControl(this.abschnittId, new UntypedFormArray([]))

    this.fragenForm.clear();

    var idx = 0;
    var scopeType: EnumValue | null = GlobalEnumsAceXfoundportalobjekt.getAsDataset().find(element => element.Value == this.portalContextService.CurrentItemContext.type) || null;
    this.fragen.forEach(frage => {
      let dateFormControl: UntypedFormControl = new UntypedFormControl(null, []);
      let textFormControl: UntypedFormControl = new UntypedFormControl(null, []);
      let textEinzeiligFormControl: UntypedFormControl = new UntypedFormControl(null, []);

      let answerFormGroup = new UntypedFormGroup({
        anfrageId: new UntypedFormControl(this.portalContextService.CurrentAnfrage.id, []),
        antwortId: new UntypedFormControl(null, []),
        reportId: new UntypedFormControl(this.portalContextService.CurrentBericht?.projektberichtId, []),
        datum: dateFormControl,
        frageId: new UntypedFormControl(frage.frageId, []),
        jaNein: new UntypedFormControl(frage.answer?.jaNein == true ? true : null, []),
        text: textFormControl,
        textEinzeilig: textEinzeiligFormControl,
        waehrung: new UntypedFormControl(frage.answer?.waehrung, []),
        ganzezahl: new UntypedFormControl(frage.answer?.ganzezahl, []),
        dezimalzahl: new UntypedFormControl(frage.answer?.dezimalzahl, []),
        scope: new UntypedFormControl(scopeType?.Value),
        auswahl: new UntypedFormControl(this.convertAuswahlAnswerToEnum(frage), []),
        mehrfachAuswahl: new UntypedFormControl(this.convertAuswahlAnswerToEnum(frage), [])
      });

      let frageFormGroup = new UntypedFormGroup({
        abschnittId: new UntypedFormControl(null, []),
        answer: answerFormGroup,
        feldTyp: new UntypedFormControl(null, []),
        frageId: new UntypedFormControl(null, []),
        infotext: new UntypedFormControl(null, []),
        isRequired: new UntypedFormControl(null, []),
        maxLength: new UntypedFormControl(null, []),
        order: new UntypedFormControl(null, []),
        texts: new UntypedFormControl([], []),
        vorlageAntwort: new UntypedFormControl([], []),
        anzahlDerZeilen: new UntypedFormControl(null, []),
        headline: new UntypedFormControl(null, []),
      });

      this.fragenForm.push(frageFormGroup);

      frageFormGroup.patchValue(frage);

      if (frage.answer && frage.answer.datum)
      dateFormControl.setValue(new Date(frage.answer.datum));
      answerFormGroup.controls['waehrung'].setValidators(Validators.min(0));
      
      if (this.isFrageRequired(frage) && this.stateService.IsEndvalidationEnabled) {
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.Textfeldeinzeilig)
        textEinzeiligFormControl.setValidators(Validators.required);
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.Wahrung)
        answerFormGroup.controls['waehrung'].setValidators(Validators.required);
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.Textfeldmehrzeilig)
        textFormControl.setValidators(Validators.required);
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.JamitBeschreibung) {
          answerFormGroup.controls["jaNein"].setValidators(Validators.required);
          textFormControl.setValidators(Validators.required);
        }
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.NeinmitBeschreibung) {
          answerFormGroup.controls["jaNein"].setValidators(Validators.required);
          textFormControl.setValidators(Validators.required);
        }
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.JaNeinmitBeschreibung){
          answerFormGroup.controls["jaNein"].setValidators(Validators.required);
          textFormControl.setValidators(Validators.required);
        }
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.JaNein)
          answerFormGroup.controls["jaNein"].setValidators(Validators.required);
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.Datum)
          dateFormControl.setValidators(Validators.required);
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.GanzeZahl)
          answerFormGroup.controls["ganzezahl"].setValidators(Validators.required);
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.Dezimalzahl)
          answerFormGroup.controls["dezimalzahl"].setValidators(Validators.required);
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.Auswahl)
          answerFormGroup.controls["auswahl"].setValidators(Validators.required);
        if (frage.feldTyp == GlobalEnumsAceFeldtyp.Mehrfachauswahl)
          answerFormGroup.controls["mehrfachAuswahl"].setValidators(Validators.required);
        frageFormGroup.markAllAsTouched();
      }
      
      if (!frage.answer)
        frage.answer = new AntwortDisplayModel();

      if (frage.answer) {
        if (!frage.answer.text && frage.vorlageAntwort) {
          let localizedVorlage = this.languageService.getCurrentLocalizedTextDisplayModel(frage.vorlageAntwort);
          if (localizedVorlage?.text)
            textFormControl.setValue(localizedVorlage.text);
        }
        
        if (frage.answer.datum)
          dateFormControl.setValue(new Date(frage.answer.datum));
      }

      this.updateEnumDescriptionOfOptions(frage);

      idx++;
    })
  }

  protected updateEnumDescriptionOfOptions(frage: FrageDisplayModel) {
    if (frage.feldTyp == GlobalEnumsAceFeldtyp.Auswahl || frage.feldTyp == GlobalEnumsAceFeldtyp.Mehrfachauswahl) {
      let frageAuswahl: EnumValue[] = [];
      frage.frageAuswahl?.auswahl?.forEach(auswahl => {
        let name = this.languageService.getCurrentLocalizedTextDisplayModel(auswahl.name)?.text ?? "";
        frageAuswahl.push({
          Name: name,
          Description: name,
          Value: auswahl.id ?? 0
        });
      });

      this.auswahlOptionen.set(frage.frageId, frageAuswahl);
    }
  }

  protected updateEnumDescriptionOfSelectedOptions(frage: any) {
    if (frage.value.feldTyp == GlobalEnumsAceFeldtyp.Mehrfachauswahl && frage.value.answer && frage.value.answer.mehrfachAuswahl) {
      frage.value.answer.mehrfachAuswahl.forEach((selectedValue: EnumValue) => {
        let name = this.auswahlOptionen.get(frage.value.frageId)?.find(auswahl => auswahl.Value == selectedValue.Value)?.Name ?? "";
        selectedValue.Description = name;
        selectedValue.Name = name;
      })
    }
  }

  protected convertAuswahlAnswerToEnum(frage: FrageDisplayModel) {
    let splittedValues: string[] = frage.answer?.textEinzeilig?.split(";") ?? [];
    let selectedValues: EnumValue[] = [];

    splittedValues.forEach(value => {
      let foundAuswahl = frage.frageAuswahl?.auswahl?.find(auswahl => auswahl.name?.find(name => name.localeCode == frage.frageAuswahl?.mainLanguageCode)?.text == value);
      let name = this.languageService.getCurrentLocalizedTextDisplayModel(foundAuswahl?.name)?.text ?? "";
      if (foundAuswahl != null) {
        selectedValues.push({
          Name: name,
          Description: name,
          Value: foundAuswahl.id ?? 0
        });
      }
    });

    if (frage.feldTyp == GlobalEnumsAceFeldtyp.Auswahl)
      return selectedValues.length > 0 ? selectedValues[0] : null;
    return selectedValues;
  }


  public get sortedFragen(): UntypedFormGroup[] {
    let sortedFragen = Object.values(<UntypedFormGroup[]>this.fragenForm.controls).sort((a, b) => a.value.order - b.value.order);

    return sortedFragen
  }

  public frageFeldTyp(value: FrageDisplayModel): GlobalEnumsAceFeldtyp {
    let filteredFrage: FrageDisplayModel | undefined = this.fragen.find(f => f.frageId == value.frageId);

    let frageTyp: GlobalEnumsAceFeldtyp = GlobalEnumsAceFeldtyp.Textfeldeinzeilig;
    if (filteredFrage && filteredFrage.feldTyp) {
      frageTyp = filteredFrage.feldTyp;
    }

    return frageTyp;
  }

  public frageText(value: FrageDisplayModel): string {
    let frage: string = (value.texts && this.languageService.getCurrentLocalizedTextDisplayModel(value.texts))?.text ?? this.languageService.instant('undefinedText');
    let asterisk: string = this.isFrageRequired(value) ? ' *' : '';
    return frage + asterisk;
  }

  public frageHeadline(value: FrageDisplayModel): string {
    return value.headline ?? "";
  }

  public frageMaxLength(value: FrageDisplayModel): number {
    return value.maxLength && value.maxLength > 0 ? value.maxLength : 999999;
  }

  public frageCharacterCounter(value: FrageDisplayModel): number | null {
    let count: number = value.answer?.textEinzeilig != null ? value.answer?.textEinzeilig?.length : 0;

    return count;
  }

  public frageWordCounter(value: FrageDisplayModel): number | null {
    let count: number = value.answer?.textEinzeilig != null ? value.answer?.textEinzeilig.trim().split(/\s+/).length : 0;
    return count;
  }

  public isFrageRequired(value: FrageDisplayModel): boolean {
    return value?.isRequired;
  }

  public onDatumChange(frage: FrageDisplayModel, value: Date): void {
    let antworten: AntwortDisplayModel[] = this.fragenForm.value;

    antworten.forEach(a => {
      if (a.frageId == frage.frageId) {
        a.datum = value.toISOString();
      }
    });

    this.fragenForm.markAsDirty();
    this.fragenForm.patchValue(antworten);
  }

  public initCKEditor(editor: any, containerId: string, frage: FrageDisplayModel, index: number) {
    this.ckeditorService
      .rows(frage.anzahlDerZeilen ?? 5)
      .initWordCount(editor, containerId, frage.maxLength ? frage.maxLength : 0);

    if(frage.maxLength && frage.maxLength > 0) {
      this.fragenForm.controls[index].valueChanges.subscribe(controlValue => {
        this.ckeditorService.validateLength(editor, frage.maxLength ? frage.maxLength : 0);
      })
    }
  }

  public isMaxVisible(frage: FrageDisplayModel): boolean {
    return frage.maxLength != null && frage.maxLength > 0;
  }

  public highestPossibleValue(frage: FrageDisplayModel): number {
    return Math.pow(10, this.frageMaxLength(frage)) - 0.01;
  }

  public highestPossibleIntValue(frage: FrageDisplayModel): number {
    return Math.pow(10, this.frageMaxLength(frage)) - 1;
  }

  protected convertAuswahlAnswerToTextEinzeilig(frageControl: any) {
    if(frageControl.value.feldTyp == GlobalEnumsAceFeldtyp.Auswahl) {
      let auswahlValue: any = frageControl.value.answer.auswahl;
      let originalFrage = this.fragen.find(originalFrage => originalFrage.frageId == frageControl.value.frageId);
      frageControl.value.answer.textEinzeilig = originalFrage?.frageAuswahl?.auswahl?.find(auswahl => auswahl.id == auswahlValue?.Value)?.name?.find(name => name.localeCode == originalFrage?.frageAuswahl?.mainLanguageCode)?.text ?? "";
    }
    else if (frageControl.value.feldTyp == GlobalEnumsAceFeldtyp.Mehrfachauswahl) {
      let auswahlArray: any[] = frageControl.value.answer.mehrfachAuswahl;
      let originalFrage = this.fragen.find(originalFrage => originalFrage.frageId == frageControl.value.frageId);
      frageControl.value.answer.textEinzeilig = "";
      auswahlArray.forEach((auswahlValue, index) => {
        frageControl.value.answer.textEinzeilig += originalFrage?.frageAuswahl?.auswahl?.find(auswahl => auswahl.id == auswahlValue?.Value)?.name?.find(name => name.localeCode == originalFrage?.frageAuswahl?.mainLanguageCode)?.text ?? "";
        if (index+1 < auswahlArray.length)
          frageControl.value.answer.textEinzeilig += ";";
      });
    }
  }

  /**
   * Save the current page.
   * 
   * @returns Promise<this>
   */
  protected save(shouldSave: boolean, moveDirection: MoveDirection): void {
    if (shouldSave && this.fragenStepForm.dirty) {

      this.fragenForm.controls.forEach(frageControl => {
        this.convertAuswahlAnswerToTextEinzeilig(frageControl);
      });

      let fragen: FrageDisplayModel[] = this.fragenForm.value;

      let antworten: AntwortDisplayModel[] = []

      fragen.forEach(frage => {
        if (frage.answer) {
          frage.answer.scope = this.portalContextService.CurrentAnfrage.objektTyp;
          frage.answer.reihenfolgeAbschnitt = this.sectionService.current()?.reihenfolge;
          frage.answer.reportId = this.portalContextService.CurrentBericht?.projektberichtId;
          frage.answer.gutachtenId = this.portalContextService.CurrentGutachten?.gutachtenId;
          antworten.push(frage.answer);
        }
      });

      
      this.portalContextService.CurrentAnfrage.fragen = this.portalContextService.CurrentAnfrage.fragen?.filter((fragen: FragenVonAbschnittDisplayModel) => fragen.abschnittId != this.abschnittId);
      this.fragenStepForm.markAsPristine();
      if (moveDirection != MoveDirection.STAY) {
        if (this.canceledRoute) {
          this.router.navigateByUrl(this.canceledRoute);
        } else {
          this.move(moveDirection);
        }
      }

      let subscription = this.antwortService.apiAntwortPost({ body: antworten }).subscribe(() => {
        this.anfrageService.apiAnfrageGetFragenByEntityAndAreaGet({ anfrageId: this.portalContextService.CurrentAnfrage.id, abschnittId: this.abschnittId, reportId: this.portalContextService.CurrentBericht?.projektberichtId, gutachtenId: this.portalContextService.CurrentGutachten?.gutachtenId ?? undefined }).subscribe(response => {
          if (response) {
            this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.portalContextService.CurrentAnfrage.id, reportId: this.portalContextService.CurrentBericht?.projektberichtId, gutachtenId: this.portalContextService.CurrentGutachten?.gutachtenId ?? undefined }).subscribe(result => {
              this.stateService.ValidationErrors = result;
            })

            let responseCache = new FragenVonAbschnittDisplayModel();
            responseCache.abschnittId = this.abschnittId;
            responseCache.fragen = response;

            if (this.portalContextService.CurrentAnfrage)
              this.portalContextService.CurrentAnfrage.fragen?.push(responseCache);

            this.fragenStepForm.patchValue(response);
  
            this.fragenStepForm.markAsPristine();
          }
        });
      });

      this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
      this.unfinishedHttpMethodsService.addSubscription(subscription);
    } else {
      this.fragenStepForm.markAsPristine();
      this.move(moveDirection);
    }
  }
}
